import { ConnectError } from '@connectrpc/connect'

// HTTP-error sentinel prefixes the Go backend returns wrapped via
// `errors.Join` / `fmt.Errorf("%w: ...", httpError.ErrBadRequest)`. Stripping
// them keeps user-facing toasts focused on the actionable message.
const SENTINEL_PREFIXES = [
  'bad request',
  'invalid request',
  'not found',
  'conflict',
  'forbidden',
  'unauthorized',
  'internal error',
]

function stripSentinelPrefix(message: string): string {
  const trimmed = message.trim()
  for (const prefix of SENTINEL_PREFIXES) {
    if (trimmed.toLowerCase().startsWith(`${prefix}:`)) {
      return trimmed.slice(prefix.length + 1).trim()
    }
    if (trimmed.toLowerCase() === prefix) {
      return ''
    }
  }
  return trimmed
}

/**
 * Extract a user-facing error description from an unknown error.
 * For ConnectError, prefer `rawMessage` (no `[code]` prefix) and strip the
 * Go HTTP-error sentinel ("bad request:", "not found:", ...) so the toast
 * shows just the actionable sentence.
 */
export function getErrorDescription(error: unknown): string {
  if (error instanceof ConnectError) {
    const cleaned = stripSentinelPrefix(error.rawMessage)
    return cleaned || error.rawMessage || 'An error occurred'
  }
  if (error instanceof Error) {
    return stripSentinelPrefix(error.message) || error.message
  }
  return 'An error occurred'
}
